export default "__VITE_ASSET__BXSxIWlR__"